/* ============================================================
   OSMANLI DOĞAL TAŞ — Niyet sayfası 3B katmanı (Canvas 2D)

   KRİSTAL: soyut bir form değil, gerçek bir kesim geometrisi.
   Sayfanın konusu taş olduğu için brilliant kesime yakın bir yapı kuruldu:
     · tabla (üst düz yüzey)
     · kron  (tabla ile kuşak arası eğik yüzler)
     · kuşak (girdle — en geniş çevre)
     · pavilion (aşağı sivrilen alt yüzler)
   Her yüzün parlaklığı, yüzey normali ile ışık yönünün skaler çarpımından
   hesaplanır; taş döndükçe yüzler sırayla parlar. Yüzler z'ye göre arkadan
   öne çizilir (painter's algorithm), yoksa arka yüzler öne taşar.
   ============================================================ */
(function (g) {
  'use strict';

  var AZ_HAREKET = false;
  try {
    AZ_HAREKET = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) { }

  function hazirla(cv) {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = cv.clientWidth || 320, h = cv.clientHeight || 320;
    if (cv.width !== Math.round(w * dpr) || cv.height !== Math.round(h * dpr)) {
      cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
    }
    var ctx = cv.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    return { ctx: ctx, w: w, h: h };
  }
  function gorunurlukBagla(cv, durum) {
    if (!window.IntersectionObserver) { durum.gorunur = true; return; }
    var io = new IntersectionObserver(function (e) { durum.gorunur = e[0].isIntersecting; }, { threshold: 0.01 });
    io.observe(cv); durum.gorunur = true; return io;
  }

  function dondurY(p, a) {
    var c = Math.cos(a), s = Math.sin(a);
    return { x: p.x * c + p.z * s, y: p.y, z: -p.x * s + p.z * c };
  }
  function dondurX(p, a) {
    var c = Math.cos(a), s = Math.sin(a);
    return { x: p.x, y: p.y * c - p.z * s, z: p.y * s + p.z * c };
  }
  function yansit(p, cx, cy, d) {
    var f = d / (d + p.z);
    return { x: cx + p.x * f, y: cy + p.y * f, f: f, z: p.z };
  }
  /* üç noktadan yüzey normali (çapraz çarpım) */
  function normal(a, b, c) {
    var u = { x: b.x - a.x, y: b.y - a.y, z: b.z - a.z };
    var v = { x: c.x - a.x, y: c.y - a.y, z: c.z - a.z };
    var n = { x: u.y * v.z - u.z * v.y, y: u.z * v.x - u.x * v.z, z: u.x * v.y - u.y * v.x };
    var l = Math.sqrt(n.x * n.x + n.y * n.y + n.z * n.z) || 1;
    return { x: n.x / l, y: n.y / l, z: n.z / l };
  }
  function hexToRgb(h) {
    h = (h || '#c9a227').replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    return { r: parseInt(h.slice(0, 2), 16), g: parseInt(h.slice(2, 4), 16), b: parseInt(h.slice(4, 6), 16) };
  }

  /**
   * cv   : canvas
   * veri : { renk:'#rrggbb', hiz:0.006 }
   */
  function kristal(cv, veri) {
    veri = veri || {};
    var durum = { calisiyor: true, gorunur: true, don: 0, renk: veri.renk || '#c9a227',
                  hedefRenk: veri.renk || '#c9a227', karisim: 1, surukle: null };
    gorunurlukBagla(cv, durum);

    var N = 8;                     /* kenar sayısı */
    var IS = { x: -0.42, y: -0.72, z: -0.55 };   /* ışık yönü */
    (function () { var l = Math.sqrt(IS.x*IS.x + IS.y*IS.y + IS.z*IS.z); IS.x/=l; IS.y/=l; IS.z/=l; })();

    /* ---- köşe noktaları ---- */
    function govde(R) {
      var tabla = [], kusak = [], i, a;
      for (i = 0; i < N; i++) {
        a = (i / N) * Math.PI * 2;
        tabla.push({ x: Math.cos(a) * R * 0.50, y: -R * 0.42, z: Math.sin(a) * R * 0.50 });
      }
      for (i = 0; i < N; i++) {
        a = ((i + 0.5) / N) * Math.PI * 2;      /* kuşak yarım adım kaydırılır — kesim böyle olur */
        kusak.push({ x: Math.cos(a) * R, y: 0, z: Math.sin(a) * R });
      }
      return { tabla: tabla, kusak: kusak, uc: { x: 0, y: R * 1.05, z: 0 } };
    }

    /* ---- yüz listesi ---- */
    function yuzler(gv) {
      var y = [], i;
      y.push({ p: gv.tabla.slice(), tur: 'tabla' });
      for (i = 0; i < N; i++) {
        var t1 = gv.tabla[i], t2 = gv.tabla[(i + 1) % N];
        var k1 = gv.kusak[i], k2 = gv.kusak[(i + 1) % N];
        y.push({ p: [t1, k1, t2], tur: 'kron' });        /* üçgen kron yüzü */
        y.push({ p: [t2, k1, k2], tur: 'kron2' });       /* ters üçgen */
        y.push({ p: [k1, gv.uc, k2], tur: 'pavilion' }); /* alt yüz */
      }
      return y;
    }

    function bas(e) { durum.surukle = { x: (e.touches ? e.touches[0] : e).clientX, don: durum.don }; }
    function hareket(e) {
      if (!durum.surukle) return;
      var x = (e.touches ? e.touches[0] : e).clientX;
      durum.don = durum.surukle.don + (x - durum.surukle.x) * 0.008;
      if (e.cancelable && e.touches) e.preventDefault();
    }
    function birak() { durum.surukle = null; }
    cv.addEventListener('mousedown', bas);
    cv.addEventListener('touchstart', bas, { passive: true });
    window.addEventListener('mousemove', hareket);
    cv.addEventListener('touchmove', hareket, { passive: false });
    window.addEventListener('mouseup', birak);
    window.addEventListener('touchend', birak);

    /* arka plan zerreleri */
    var zerre = [];
    for (var z = 0; z < 34; z++) {
      zerre.push({ a: Math.random() * 6.2832, r: 0.6 + Math.random() * 0.7,
                   h: (Math.random() - 0.5) * 1.6, s: 0.2 + Math.random() * 0.5, p: Math.random() * 6.28 });
    }

    var t = 0, suRenk = hexToRgb(durum.renk), hedef = hexToRgb(durum.renk);
    function cerceve() {
      if (!durum.calisiyor) return;
      requestAnimationFrame(cerceve);
      if (!durum.gorunur) return;

      var h = hazirla(cv), ctx = h.ctx, w = h.w, hh = h.h;
      var cx = w / 2, cy = hh * 0.48, d = 760;
      var R = Math.min(w, hh) * 0.30;

      ctx.clearRect(0, 0, w, hh);
      t += 1;
      if (!durum.surukle && !AZ_HAREKET) durum.don += (veri.hiz || 0.0055);

      /* renk geçişi (niyet değiştiğinde yumuşak) */
      if (durum.karisim < 1) {
        durum.karisim = Math.min(1, durum.karisim + 0.035);
      }
      var kr = {
        r: Math.round(suRenk.r + (hedef.r - suRenk.r) * durum.karisim),
        g: Math.round(suRenk.g + (hedef.g - suRenk.g) * durum.karisim),
        b: Math.round(suRenk.b + (hedef.b - suRenk.b) * durum.karisim)
      };

      /* --- arka plan zerreleri --- */
      zerre.forEach(function (zr) {
        if (!AZ_HAREKET) zr.a += zr.s * 0.0016;
        var p = yansit(dondurX({ x: Math.cos(zr.a) * R * zr.r * 2.1, y: zr.h * R,
                                 z: Math.sin(zr.a) * R * zr.r * 2.1 }, 0.30), cx, cy, d);
        var par = (0.10 + 0.16 * Math.sin(t * 0.02 + zr.p)) * p.f;
        ctx.fillStyle = 'rgba(' + kr.r + ',' + kr.g + ',' + kr.b + ',' + par.toFixed(3) + ')';
        ctx.beginPath(); ctx.arc(p.x, p.y, 1.6 * p.f, 0, 6.2832); ctx.fill();
      });

      /* --- taşın altındaki ışık havuzu --- */
      var hav = ctx.createRadialGradient(cx, cy + R * 1.25, 2, cx, cy + R * 1.25, R * 1.5);
      hav.addColorStop(0, 'rgba(' + kr.r + ',' + kr.g + ',' + kr.b + ',0.34)');
      hav.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = hav;
      ctx.beginPath(); ctx.ellipse(cx, cy + R * 1.25, R * 1.5, R * 0.34, 0, 0, 6.2832); ctx.fill();

      /* --- kristal --- */
      var gv = govde(R);
      var egim = 0.30 + (AZ_HAREKET ? 0 : Math.sin(t * 0.004) * 0.05);
      function don(p) { return dondurX(dondurY(p, durum.don), egim); }

      var liste = yuzler(gv).map(function (f) {
        var d3 = f.p.map(don);
        var pr = d3.map(function (p) { return yansit(p, cx, cy, d); });
        var oz = d3.reduce(function (a, p) { return a + p.z; }, 0) / d3.length;
        var nr = d3.length >= 3 ? normal(d3[0], d3[1], d3[2]) : { x: 0, y: -1, z: 0 };
        return { pr: pr, oz: oz, nr: nr, tur: f.tur };
      }).sort(function (a, b) { return b.oz - a.oz; });

      liste.forEach(function (f) {
        /* ışık: normal · ışık yönü */
        var lam = -(f.nr.x * IS.x + f.nr.y * IS.y + f.nr.z * IS.z);
        var parlak = Math.max(0, lam);
        var taban = f.tur === 'tabla' ? 0.42 : (f.tur === 'pavilion' ? 0.16 : 0.24);
        var yog = Math.min(1, taban + parlak * 0.85);
        /* arka yüzler yarı saydam görünsün — taş "camsı" dursun */
        var arka = f.oz > 0;
        var alfa = arka ? 0.30 : 0.94;

        ctx.beginPath();
        ctx.moveTo(f.pr[0].x, f.pr[0].y);
        f.pr.slice(1).forEach(function (p) { ctx.lineTo(p.x, p.y); });
        ctx.closePath();

        var rr = Math.round(kr.r * (0.35 + yog * 0.75));
        var gg = Math.round(kr.g * (0.35 + yog * 0.75));
        var bb = Math.round(kr.b * (0.35 + yog * 0.75));
        ctx.fillStyle = 'rgba(' + Math.min(255, rr) + ',' + Math.min(255, gg) + ',' + Math.min(255, bb) + ',' + alfa + ')';
        ctx.fill();

        ctx.strokeStyle = 'rgba(255,255,255,' + (arka ? 0.06 : 0.20) + ')';
        ctx.lineWidth = 0.9;
        ctx.stroke();

        /* keskin parlama: ışığa tam bakan ön yüzler */
        if (!arka && parlak > 0.82) {
          ctx.fillStyle = 'rgba(255,255,255,' + ((parlak - 0.82) * 1.5).toFixed(3) + ')';
          ctx.fill();
        }
      });

      /* --- üstte ince ışık halesi --- */
      var hale = ctx.createRadialGradient(cx, cy - R * 0.2, R * 0.1, cx, cy, R * 2.1);
      hale.addColorStop(0, 'rgba(' + kr.r + ',' + kr.g + ',' + kr.b + ',0.16)');
      hale.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = hale;
      ctx.beginPath(); ctx.arc(cx, cy, R * 2.1, 0, 6.2832); ctx.fill();
    }
    requestAnimationFrame(cerceve);

    return {
      durdur: function () {
        durum.calisiyor = false;
        window.removeEventListener('mousemove', hareket);
        window.removeEventListener('mouseup', birak);
        window.removeEventListener('touchend', birak);
      },
      renkAyarla: function (yeni) {
        suRenk = hexToRgb(durum.renk);
        hedef = hexToRgb(yeni);
        durum.renk = yeni;
        durum.karisim = 0;
      }
    };
  }

  g.ODTKristal = { kristal: kristal, AZ_HAREKET: AZ_HAREKET };
})(typeof window !== 'undefined' ? window : globalThis);
